// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ITimePeriod {
	start: string | undefined;

	end: string | undefined;

	$type?: string | undefined;
}
export class TimePeriod {
	constructor(data?: ITimePeriod) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.start) { this.start = new Date(data.start); }
		if (data.end) { this.end = new Date(data.end); }
	}

	start: Date | undefined = new Date();

	end: Date | undefined = new Date();

	static $type: string = "Shared.Models.View.TimePeriod, ";
	$type?: string | undefined = TimePeriod.$type;
}

